/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const thirdPartyEnumsNatureOfCompromiseOptionEnum = {
    UnauthorizedAccess: 'UnauthorizedAccess',
    DataLeak: 'DataLeak',
    Ransom: 'Ransom',
    Malware: 'Malware',
    AccountCompromise: 'AccountCompromise',
    Other: 'Other',
} as const;

export type ThirdPartyEnumsNatureOfCompromiseOptionEnumKey =
    (typeof thirdPartyEnumsNatureOfCompromiseOptionEnum)[keyof typeof thirdPartyEnumsNatureOfCompromiseOptionEnum];

export type ThirdPartyEnumsNatureOfCompromiseOption = ThirdPartyEnumsNatureOfCompromiseOptionEnumKey;
